import axios from 'axios';

const ROOT = 'api/v1/users';

const UserApiApi = {
  getListOfActiveUsers(sitePatientIdentifier = '', patientItemGroupId = '', logRowId = '') {
    let point = `${ROOT}/personnels?sitePatientIdentifier=${sitePatientIdentifier}&patientItemGroupId=${patientItemGroupId}&logRowId=${logRowId}&whodiditFlag=1`;
    if (sitePatientIdentifier) {
      point = `${point}`;
    }
    return axios.get(point);
  },

  getListOfStudyManagers(sitePatientIdentifier = '') {
    let point = `${ROOT}/personnels/SM`;
    if (sitePatientIdentifier) {
      point = `${point}?sitePatientIdentifier=${sitePatientIdentifier}&whodiditFlag=1`;
    }
    return axios.get(point);
  },

  getUserInfo() {
    return axios.get(`${ROOT}/info/user`);
  },

  getUserPreferences() {
    return axios.get(`${ROOT}/info/me/preferences`, { hideLoader: true });
  },

  getGlobalEnvironmentSettings() {
    return axios.get(`api/v1/global-environment-settings/`, { hideLoader: true });
  },

  changeGlobalEnvironmentSettings(settings) {
    return axios.put(`api/v1/global-environment-settings/`, settings, { hideLoader: true });
  },

  updateUserPreferences(preferences) {
    return axios.put(`${ROOT}/info/me/preferences`, preferences, { hideLoader: true });
  },

  checkFirstTimeLogin() {
    return axios.get(`${ROOT}/firstTimeLogin`);
  },

  writeLogInTime() {
    return axios.get(`${ROOT}/login`);
  },

  writeLogoutTime(id) {
    return axios.post(`${ROOT}/logout`, id, {
      headers: {
        'Content-Type': 'text/plain'
      }
    });
  },
  getAssigneesBySsu(ssuId) {
    return axios.get(`${ROOT}/study-sites/${ssuId}/personnel`, {
      hideLoader: true
    });
  },
  getAllEligibleAssignees() {
    return axios.get(`${ROOT}/eligible-assignees`);
  },
  getUserSsuRelatedRoles(ssuPatientId) {
    return axios.get(`${ROOT}/site-patients/${ssuPatientId}/roles`);
  },
  getPersonnelBySsu(ssuIds) {
    return axios.post(
      `${ROOT}/study-sites/personnel`,
      { ssuIds },
      {
        hideLoader: true
      }
    );
  },
  searchPersonnels(ssuId, searchRequest) {
    return axios.post(`${ROOT}/personnels/search?ssuId=${ssuId}`, searchRequest, { hideLoader: true });
  },
  getPersonnelDetails(ssuId, personnelId) {
    return axios.get(`${ROOT}/personnels/${personnelId}?ssuId=${ssuId}`, { hideLoader: true });
  },
  addOrUpdatePersonnel(ssuId, addOrUpdatePersonnelRequest) {
    return axios.post(`${ROOT}/personnels?ssuId=${ssuId}`, addOrUpdatePersonnelRequest);
  },
  addRole(ssuId, personnelId, addRoleRequest) {
    return axios.post(`${ROOT}/personnels/${personnelId}/add-role?ssuId=${ssuId}`, addRoleRequest);
  },
  expireSsuRole(ssuId, personnelId, expireRoleRequest) {
    return axios.post(`${ROOT}/personnels/${personnelId}/expire-ssu-role?ssuId=${ssuId}`, expireRoleRequest);
  },
  resetPassword(ssuId, personnelId) {
    return axios.post(`${ROOT}/personnels/${personnelId}/reset-password?ssuId=${ssuId}`);
  },
  resendInvitation(ssuId, personnelId) {
    return axios.post(`${ROOT}/personnels/${personnelId}/resend-invitation?ssuId=${ssuId}`);
  }
};

export default UserApiApi;
